import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionContractInfo } from "../../market/actionContractInfo";
export var epicSoundsMarketContractTrash = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionContractInfo.RequestDismiss; }), tap(function () { return utilSound.event(IdEventSoundCore.MarketContractTrash); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsMarketContractTrash.ts
// module id = 2407
// module chunks = 3